import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            upper: 1.5,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 1.5,
            upper: 1.9,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 1.9,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
